import React, { useContext, useRef, useState } from "react";
import "./AddChannelModal.css";
import { IoCloseOutline, IoDocumentTextOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { GrAttachment } from "react-icons/gr";
import { CgCloseO } from "react-icons/cg";
import { useLanguage } from "../../../../LanguageProvider";
import { useToaster } from "../../../../ToasterProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { GeneralContext } from "../../../../GeneralProvider";

export default function AddChannelModal({ isOpen, onClose }) {
  const { getTranslation } = useLanguage();
  const { handleCreateChannel } = useContext(GeneralContext);
  const { toastWarning } = useToaster();

  // TEXT / PRIVACY
  const [channelName, setChannelName] = useState("");
  const [description, setDescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);

  // LOGO
  const [selectedFiles, setSelectedFiles] = useState([]); // logo için tek dosya kullanacağız
  const fileInputRef = useRef();

  // TOP BANNER
  const [selectedBannerFiles, setSelectedBannerFiles] = useState([]); // banner için tek dosya
  const bannerInputRef = useRef();

  if (!isOpen) return null;

  const resetStates = () => {
    setSelectedFiles([]);
    setSelectedBannerFiles([]);
    setChannelName("");
    setDescription("");
    setIsPrivate(false);
  };

  const fileToPayload = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const extension = file.name.split(".").pop();
        const title =
          file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
        resolve({ file: base64String, extension, title });
      };
      reader.readAsDataURL(file);
    });

  // LOGO seçimi
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const payload = await fileToPayload(files[0]);
    setSelectedFiles([payload]); // tek dosya
  };

  // BANNER seçimi
  const handleBannerChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const payload = await fileToPayload(files[0]);
    setSelectedBannerFiles([payload]); // tek dosya
  };

  const removeFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const removeBannerFile = (index) => {
    setSelectedBannerFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const onComplete = () => {
    const logoToSend = selectedFiles[0];
    const topBannerToSend = selectedBannerFiles[0];

    handleCreateChannel(
      channelName,
      description,
      !isPrivate,
      logoToSend,
      topBannerToSend // logo'dan sonra banner
    );

    resetStates();
    onClose();
  };

  const handleOnClose = () => {
    resetStates();
    onClose();
  };

  return (
    <div className="add-channel-modal-overlay">
      <div className="add-channel-modal-container">
        <IoCloseOutline
          className="add-channel-modal-button close"
          onClick={handleOnClose}
        />

        <p className="add-channel-modal-title">
          {getTranslation("createChannel")}
        </p>

        <span
          className="add-channel-modal-title"
          style={{
            alignItems: "center",
            gap: "15px",
            display: "flex",
            flexDirection: "row",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          {getTranslation("private")}
          <input
            type="checkbox"
            checked={isPrivate}
            onChange={() => setIsPrivate(!isPrivate)}
          />
        </span>

        <AddModalInputField
          icon={<TbStack2 size={22} style={{ width: "25px" }} />}
          placeholder={getTranslation("channelName") + "*"}
          value={channelName}
          onChange={(e) => setChannelName(e.target.value)}
          type={"text"}
        />

        <div className="add-task-modal-content">
          <IoDocumentTextOutline
            size={20}
            style={{
              width: "25px",
              alignSelf: "flex-start",
              marginTop: "10px",
            }}
          />
          <textarea
            className="add-task-modal-textarea"
            placeholder={getTranslation("description")}
            value={description}
            rows={6}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>

        {/* LOGO & BANNER yan yana */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 16,
            alignItems: "start",
            marginTop: 15,
          }}
        >
          {/* LOGO BLOĞU */}
          <div
            style={{
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "6px",
              display: "flex",
            }}
          >
            <span
              style={{
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                display: "flex",
                gap: "5px",
              }}
            >
              <span className="add-channel-modal-attachments-icon">
                <GrAttachment />
              </span>
              <span className="add-channel-modal-attachments">
                {getTranslation("uploadChannelLogo")}
              </span>
            </span>

            <div className="add-channel-modal-select-file-holder">
              <button
                className="action-button"
                onClick={() => fileInputRef.current.click()}
              >
                {getTranslation("selectFile")}
              </button>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.gif,.webp"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>

            {selectedFiles.length > 0 && (
              <div
                style={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "8px",
                  padding: "8px 0",
                  width: "100%",
                }}
              >
                {selectedFiles.map((file, index) => (
                  <div
                    className="add-channel-modal-added-attachment-chip"
                    key={`logo-${index}`}
                  >
                    <span className="add-channel-modal-added-attachment-chip-title">
                      {file.title}
                    </span>
                    <CgCloseO
                      onClick={() => removeFile(index)}
                      style={{
                        cursor: "var(--pointer)",
                        minWidth: "14px",
                        minHeight: "14px",
                        width: "14px",
                        height: "14px",
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* BANNER BLOĞU */}
          <div
            style={{
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "6px",
              display: "flex",
            }}
          >
            <span
              style={{
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                display: "flex",
                gap: "5px",
              }}
            >
              <span className="add-channel-modal-attachments-icon">
                <GrAttachment />
              </span>
              <span className="add-channel-modal-attachments">
                {getTranslation("uploadChannelBanner") || "Banner Yükle"}
              </span>
            </span>

            <div className="add-channel-modal-select-file-holder">
              <button
                className="action-button"
                onClick={() => bannerInputRef.current.click()}
              >
                {getTranslation("selectFile")}
              </button>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.gif,.webp"
                ref={bannerInputRef}
                style={{ display: "none" }}
                onChange={handleBannerChange}
              />
            </div>

            {selectedBannerFiles.length > 0 && (
              <div
                style={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "8px",
                  padding: "8px 0",
                  width: "100%",
                }}
              >
                {selectedBannerFiles.map((file, index) => (
                  <div
                    className="add-channel-modal-added-attachment-chip"
                    key={`banner-${index}`}
                  >
                    <span className="add-channel-modal-added-attachment-chip-title">
                      {file.title}
                    </span>
                    <CgCloseO
                      onClick={() => removeBannerFile(index)}
                      style={{
                        cursor: "var(--pointer)",
                        minWidth: "14px",
                        minHeight: "14px",
                        width: "14px",
                        height: "14px",
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="add-channel-modal-actions">
          <button
            onClick={onComplete}
            className="add-channel-modal-button create"
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}